"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsxLoader = jsxLoader;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _boundedContexts = require("../boundedContexts");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var BOUNDED_CONTEXT_IMPORTS_MAP = {
  'destination/modules/': function () {
    var _destinationModules = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(subPath) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!subPath.endsWith('.lazy')) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return import(
              /* webpackMode: 'lazy-once', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
              'destination/modules/' + subPath + '.tsx');

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
              if (!(subPath.startsWith('Customization') || subPath.startsWith('DebugMode'))) {
                _context.next = 8;
                break;
              }

              _context.next = 7;
              return import(
              /* webpackMode: 'lazy-once', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
              'destination/modules/' + subPath + '.tsx');

            case 7:
              return _context.abrupt("return", _context.sent);

            case 8:
              _context.next = 10;
              return import(
              /* webpackMode: 'eager', webpackExclude: /(server|\.(spec|test)\.tsx?$|Customization|DebugMode|\.lazy)/ */
              'destination/modules/' + subPath + '.tsx');

            case 10:
              return _context.abrupt("return", _context.sent);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function destinationModules(_x) {
      return _destinationModules.apply(this, arguments);
    }

    return destinationModules;
  }(),
  'control/modules/': function () {
    var _controlModules = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(subPath) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return import(
              /* webpackMode: 'lazy-once', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
              'control/modules/' + subPath + '.tsx');

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function controlModules(_x2) {
      return _controlModules.apply(this, arguments);
    }

    return controlModules;
  }(),
  'shared/modules/': function () {
    var _sharedModules = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(subPath) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return import(
              /* webpackMode: 'eager', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
              'shared/modules/' + subPath + '.tsx');

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function sharedModules(_x3) {
      return _sharedModules.apply(this, arguments);
    }

    return sharedModules;
  }()
};

function jsxLoader(_x4) {
  return _jsxLoader.apply(this, arguments);
}

function _jsxLoader() {
  _jsxLoader = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(componentPath) {
    var boundedContext, _file$cssAnchorName2, _subPath, file;

    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            boundedContext = (0, _boundedContexts.getBoundedContextOfComponent)(componentPath);

            if (!(boundedContext !== undefined)) {
              _context9.next = 15;
              break;
            }

            _context9.prev = 2;
            _subPath = getSubPath(componentPath, boundedContext);
            _context9.next = 6;
            return BOUNDED_CONTEXT_IMPORTS_MAP[boundedContext](_subPath);

          case 6:
            file = _context9.sent;
            return _context9.abrupt("return", [(_file$cssAnchorName2 = file.cssAnchorName) !== null && _file$cssAnchorName2 !== void 0 ? _file$cssAnchorName2 : null, file.default]);

          case 10:
            _context9.prev = 10;
            _context9.t0 = _context9["catch"](2);

            if (!(_context9.t0.code !== 'MODULE_NOT_FOUND')) {
              _context9.next = 14;
              break;
            }

            throw _context9.t0;

          case 14:
            throw new Error("[import|Bounded Context] Component ".concat(componentPath, " not found"));

          case 15:
            _context9.next = 17;
            return legacyJsxLoader(componentPath);

          case 17:
            return _context9.abrupt("return", _context9.sent);

          case 18:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[2, 10]]);
  }));
  return _jsxLoader.apply(this, arguments);
}

var getSubPath = function getSubPath(componentPath, boundedContext) {
  /**
   * For some reasons, webpack requires import() function to have a literal string with a trailing slash.
   * This is why we cut the first chunk from the componentPath and write it manually
   */
  return componentPath.replace(boundedContext, '');
};

var LEGACY_IMPORTS_GUESSING_QUEUE = [/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(subPath) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(subPath.startsWith('settings/') || subPath.startsWith('theme-configuration/') || subPath.startsWith('admin-toolbar/') || subPath.endsWith('.lazy'))) {
              _context4.next = 4;
              break;
            }

            _context4.next = 3;
            return import(
            /* webpackMode: 'lazy-once', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
            'preact-components/' + subPath + '.tsx');

          case 3:
            return _context4.abrupt("return", _context4.sent);

          case 4:
            _context4.next = 6;
            return import(
            /* webpackMode: 'eager', webpackExclude: /(server|\.(spec|test)\.tsx?$|settings|theme-configuration|admin-toolbar|\.lazy)/ */
            'preact-components/' + subPath + '.tsx');

          case 6:
            return _context4.abrupt("return", _context4.sent);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x5) {
    return _ref.apply(this, arguments);
  };
}(), /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(subPath) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(subPath.startsWith('settings/') || subPath.startsWith('theme-configuration/') || subPath.startsWith('admin-toolbar/') || subPath.endsWith('.lazy'))) {
              _context5.next = 4;
              break;
            }

            _context5.next = 3;
            return import(
            /* webpackMode: 'lazy-once', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
            'preact-components/' + subPath + '.sync.tsx');

          case 3:
            return _context5.abrupt("return", _context5.sent);

          case 4:
            _context5.next = 6;
            return import(
            /* webpackMode: 'eager', webpackExclude: /(server|\.(spec|test)\.tsx?$|settings|theme-configuration|admin-toolbar|\.lazy)/ */
            'preact-components/' + subPath + '.sync.tsx');

          case 6:
            return _context5.abrupt("return", _context5.sent);

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x6) {
    return _ref2.apply(this, arguments);
  };
}(), /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(subPath) {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(subPath.startsWith('settings/') || subPath.startsWith('theme-configuration/') || subPath.startsWith('admin-toolbar/') || subPath.endsWith('.lazy'))) {
              _context6.next = 4;
              break;
            }

            _context6.next = 3;
            return import(
            /* webpackMode: 'lazy-once', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
            'preact-components/' + subPath + '.js');

          case 3:
            return _context6.abrupt("return", _context6.sent);

          case 4:
            _context6.next = 6;
            return import(
            /* webpackMode: 'eager', webpackExclude: /(server|\.(spec|test)\.tsx?$|settings|theme-configuration|admin-toolbar|\.lazy)/ */
            'preact-components/' + subPath + '.js');

          case 6:
            return _context6.abrupt("return", _context6.sent);

          case 7:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function (_x7) {
    return _ref3.apply(this, arguments);
  };
}(), /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(subPath) {
    return _regenerator.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!(subPath.startsWith('settings/') || subPath.startsWith('theme-configuration/') || subPath.startsWith('admin-toolbar/') || subPath.endsWith('.lazy'))) {
              _context7.next = 4;
              break;
            }

            _context7.next = 3;
            return import(
            /* webpackMode: 'lazy-once', webpackExclude: /(server|\.(spec|test)\.tsx?$)/ */
            'preact-components/' + subPath + '.sync.js');

          case 3:
            return _context7.abrupt("return", _context7.sent);

          case 4:
            _context7.next = 6;
            return import(
            /* webpackMode: 'eager', webpackExclude: /(server|\.(spec|test)\.tsx?$|settings|theme-configuration|admin-toolbar|\.lazy)/ */
            'preact-components/' + subPath + '.sync.js');

          case 6:
            return _context7.abrupt("return", _context7.sent);

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function (_x8) {
    return _ref4.apply(this, arguments);
  };
}()];

var legacyJsxLoader = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(derivedComponentNameFromFilePath) {
    var _iterator, _step, imp, _file$cssAnchorName, file;

    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _iterator = _createForOfIteratorHelper(LEGACY_IMPORTS_GUESSING_QUEUE);
            _context8.prev = 1;

            _iterator.s();

          case 3:
            if ((_step = _iterator.n()).done) {
              _context8.next = 18;
              break;
            }

            imp = _step.value;
            _context8.prev = 5;
            _context8.next = 8;
            return imp(derivedComponentNameFromFilePath);

          case 8:
            file = _context8.sent;
            return _context8.abrupt("return", [(_file$cssAnchorName = file.cssAnchorName) !== null && _file$cssAnchorName !== void 0 ? _file$cssAnchorName : null, file.default]);

          case 12:
            _context8.prev = 12;
            _context8.t0 = _context8["catch"](5);

            if (!(_context8.t0.code !== 'MODULE_NOT_FOUND')) {
              _context8.next = 16;
              break;
            }

            throw _context8.t0;

          case 16:
            _context8.next = 3;
            break;

          case 18:
            _context8.next = 23;
            break;

          case 20:
            _context8.prev = 20;
            _context8.t1 = _context8["catch"](1);

            _iterator.e(_context8.t1);

          case 23:
            _context8.prev = 23;

            _iterator.f();

            return _context8.finish(23);

          case 26:
            throw new Error("[import|Legacy] Component ".concat(derivedComponentNameFromFilePath, " not found"));

          case 27:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[1, 20, 23, 26], [5, 12]]);
  }));

  return function legacyJsxLoader(_x9) {
    return _ref5.apply(this, arguments);
  };
}();